import { Box } from "@material-ui/core";
import { PermissionedUser } from "./PermissionedUser";
import { User } from "../../../domain/User";
import { RecipientUser } from "../../../domain/RecipientsViewModel";

type PermissionsListProps = {
  users: RecipientUser[];
  userLookups: User[];
  onDelete: (userId: string) => void;
  allowReassignment: boolean;
};

export const PermissionsList: React.FC<PermissionsListProps> = ({
  users,
  userLookups,
  onDelete,
  allowReassignment,
}) => {
  const getUser = (upn: string | undefined) =>
    (upn && userLookups.find((user) => user.upn === upn)) || null;
  return (
    <Box display="flex" flexWrap="wrap">
      {users
        .map((user) => getUser(user.upn))
        .filter((user) => !!user)
        .sort((a, b) => (a!.id > b!.id ? 1 : -1))
        .map((user) => (
          <PermissionedUser
            user={user!}
            onDelete={onDelete}
            key={user!.id}
            allowReassignment={allowReassignment}
          />
        ))}
    </Box>
  );
};
